<template>
  <v-list style="background: none">
    <v-list-item-group>
      <v-subheader>{{ title }}</v-subheader>
      <slot />
    </v-list-item-group>
  </v-list>
</template>

<script>
export default {
  name: 'OverviewListGroup',

  props: {
    title: String
  }
}
</script>
